<template>
  <el-tag style="height: auto" :type="getTagType">
    {{ $t('inventory.supplier') }}: {{ provider.first_name }}
    {{ provider.last_name }}
    <br />
    {{ $t('common_words.nit') }}:
    {{ provider.nit }}
    <br />
    {{ $t('inventory.bank_account') }}:
    {{ provider.bank_account }}
    <br />
    {{ $t('inventory.account_type') }}:
    {{ provider.account_type }}
    <br />
    {{ $t('inventory.bank_name') }}:
    {{ provider.bank_name }}
    <br />
    <hr>
    {{ $t('inventory.contact_information') }}:
    <div v-for="(contact, index) in provider.provider_contacts" :key="index">
      {{ $t('common_words.phone') }}:
      {{ contact.phone ? contact.phone : $t('common_words.no_assignment') }}
      <br />
      {{ $t('common_words.email') }}:
      {{ contact.email ? contact.email : $t('common_words.no_assignment') }}
      <br> 
      {{ $t('inventory.email_type') }}:
      <div
        v-if="
          contact.provider_type_email && contact.provider_type_email.length > 0
        "
      >
        <div
          v-for="(emailType, index) in contact.provider_type_email"
          :key="index"
        >
          <el-tag size="mini">{{ emailType.type }}</el-tag>
        </div>
      </div>
      <div v-else>
        <el-tag size="mini">{{ $t('common_words.no_assignment') }}</el-tag>
      </div>
    </div>
    <br />
  </el-tag>
</template>
<script>
export default {
  name: 'provider-tag',
  props: {
    provider: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getTagType() {
      return this.provider.deleted_at ? `danger` : `info`;
    },
  },
};
</script>
